import { useMsal } from "@azure/msal-react";
import UnAuthenticatedRoutes from "./UnauthenticatedRoutes";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { Loading } from "../ui-components/Loading";
import { ChatProvider } from "../contexts/ChatContext";
import { GoogleMapsProvider } from "../contexts/GoogleMapsProvider";

function Routes() {
  //get current user
  const user = useMsal();

  const expired = user.instance.getActiveAccount()?.idTokenClaims?.exp;
  const hasExpired = expired ? new Date(expired * 1000) < new Date() : false;

  var userLoading =
    user.inProgress === InteractionStatus.HandleRedirect ||
    user.inProgress === InteractionStatus.AcquireToken ||
    user.inProgress === InteractionStatus.Login ||
    user.inProgress === InteractionStatus.SsoSilent;

  if (userLoading) return <Loading />;

  const isLoggedOutPage = window.location.pathname === "/logged-out";
  if (
    (user.accounts.length === 0 ||
      hasExpired ||
      !user.instance.getActiveAccount()) &&
    !isLoggedOutPage
  ) {
    console.log("User is not logged in");
    return (
      <BrowserRouter>
        <UnAuthenticatedRoutes />
      </BrowserRouter>
    );
  }
  if (isLoggedOutPage && user.accounts.length === 0) {
    return (
      <BrowserRouter>
        <UnAuthenticatedRoutes />
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter>
      <GoogleMapsProvider>
        <ChatProvider>
          <AuthenticatedRoutes />
        </ChatProvider>
      </GoogleMapsProvider>
    </BrowserRouter>
  );
}

export default Routes;
